// ADT | Авто для тебе — site content (Ukrainian)

export const CONTACT = {
  phoneDisplay: "+38 096 868 95 74",
  phoneRaw: "+380968689574",
  whatsapp: "https://wa.me/380968689574",
  viber: "viber://chat?number=%2B380968689574",
  telegram: "tg://resolve?phone=380968689574",
  messenger: "#", // TODO: replace with real Messenger link
  signal: "https://signal.me/#p/+380968689574",
};

export const SOCIALS = {
  facebook: "https://www.facebook.com/adt.avtodlatebe",
  instagram: "https://www.instagram.com/adt.avtodlatebe",
  tiktok: "#",
  x: "#",
  youtube: "#",
  telegram: "#",
};

export const LOGO = {
  badge:
    "https://customer-assets.emergentagent.com/job_personal-auto-select/artifacts/o2stl85c_15368.png",
  wordmark:
    "https://customer-assets.emergentagent.com/job_personal-auto-select/artifacts/0wj3icua_15367.jpg",
  wide:
    "https://customer-assets.emergentagent.com/job_personal-auto-select/artifacts/8rprt0a4_15415.png",
  transparent:
    "https://customer-assets.emergentagent.com/job_abd19286-1811-494e-8226-4928c2da1168/artifacts/6ko1gnkg_magicut_1781967350853.png",
};

export const HERO = {
  badges: ["ПІДБІР", "ДІАГНОСТИКА", "МИТНИЦЯ", "РЕЄСТРАЦІЯ"],
  title: "Авто для тебе",
  subtitle: "Підбір автомобілів по всій Європі під ваш бюджет та вимоги",
  lead:
    "Я не перекупник і не посередник. Увесь процес я веду особисто — від пошуку автомобіля до передачі клієнту на українських номерах. Особистий огляд, професійна діагностика, перевірка історії та документів.",
  image:
    "https://static.prod-images.emergentagent.com/jobs/abd19286-1811-494e-8226-4928c2da1168/images/32ace7b2164e30400c67d417c0bccaed76605d80eb6d605b65f9990afc657304.png",
};

export const WHY = [
  {
    icon: "UserCheck",
    title: "Особистий підхід",
    text: "Увесь процес веду особисто. Клієнт спілкується лише з однією людиною від першого дзвінка до отримання авто.",
  },
  {
    icon: "ShieldOff",
    title: "Без посередників",
    text: "Жодних перекупників і прихованих ланцюжків. Чесна оцінка без прикрашання та прихованих проблем.",
  },
  {
    icon: "MapPin",
    title: "Особистий виїзд",
    text: "Виїжджаю до автомобіля будь-де в Європі та оглядаю кожне авто на місці перед купівлею.",
  },
  {
    icon: "Gauge",
    title: "Власна діагностика",
    text: "Комп'ютерна діагностика та власне обладнання. Перевірка лакофарбового покриття товщиноміром.",
  },
  {
    icon: "FileSearch",
    title: "Перевірка історії",
    text: "Перевірка документів, історії, реального пробігу. Виявлення прихованих ремонтів та ДТП ще до купівлі.",
  },
  {
    icon: "Wrench",
    title: "Досвід у автобізнесі",
    text: "Багаторічна практика в автобазарі, автосервісі та шиномонтажі. Рекомендую лише ті авто, які купив би собі.",
  },
];

export const STEPS = [
  { n: "01", title: "Задання вимог та бюджету", text: "Обговорюємо ваші очікування, бюджет та параметри авто." },
  { n: "02", title: "Пошук відповідних авто", text: "Підбираю кілька варіантів по всій Європі під ваші вимоги." },
  { n: "03", title: "Особистий огляд", text: "Особисто виїжджаю до автомобіля та оглядаю його на місці." },
  { n: "04", title: "Діагностика та історія", text: "Комп'ютерна діагностика, товщиномір, перевірка історії." },
  { n: "05", title: "Фото та відео з місця", text: "Детальний фото- та відеозвіт безпосередньо з місця огляду." },
  { n: "06", title: "Купівля авто", text: "Після вашого схвалення оформлюю купівлю автомобіля." },
  { n: "07", title: "Доставка в Україну", text: "Організовую безпечне транспортування авто до України." },
  { n: "08", title: "Розмитнення", text: "Проходимо митне оформлення з усіма документами." },
  { n: "09", title: "Реєстрація авто", text: "Постановка на облік та реєстрація в Україні." },
  { n: "10", title: "Передача клієнту", text: "Передаю автомобіль вже на українських номерах." },
];

export const EXPERIENCE = {
  title: "Мій досвід",
  lead:
    "Чех з багаторічним досвідом роботи в автобізнесі. Знаю автомобілі не з реклами, а зсередини.",
  points: [
    "Багаторічна практика в автобізнесі",
    "Досвід роботи з автобазаром",
    "Досвід роботи з автосервісом",
    "Досвід роботи з шиномонтажем",
    "Купівля автомобілів по всій Європі",
  ],
  image:
    "https://customer-assets.emergentagent.com/job_personal-auto-select/artifacts/vuc4q761_15418.jpg",
};

export const POST_PURCHASE = {
  title: "Допомога навіть після купівлі",
  lead: "Клієнт не залишається без підтримки після ввезення автомобіля.",
  points: [
    "Допомога у вирішенні питань з документацією",
    "Підтримка під час митного оформлення",
    "Підготовка документів від початку процесу — навіть на випадок спірної оцінки вартості авто",
    "Співпраця з юристами у складних випадках",
    "Ви завжди можете звернутися за допомогою після доставки",
  ],
  image:
    "https://images.unsplash.com/photo-1761014586544-53fe5e1f1e25?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const GALLERY = [
  { url: "https://customer-assets.emergentagent.com/job_personal-auto-select/artifacts/wq8hkli3_15433.jpg", alt: "Ford Mondeo з DAT Autohaus, Німеччина" },
  { url: "https://customer-assets.emergentagent.com/job_personal-auto-select/artifacts/vuc4q761_15418.jpg", alt: "DAT Autohaus — підбір авто" },
  { url: "https://customer-assets.emergentagent.com/job_personal-auto-select/artifacts/uz61zmjk_15421.jpg", alt: "Особистий огляд на місці" },
  { url: "https://customer-assets.emergentagent.com/job_personal-auto-select/artifacts/mpetl4x2_15424.jpg", alt: "Перевірка авто перед купівлею" },
  { url: "https://customer-assets.emergentagent.com/job_personal-auto-select/artifacts/oc4yf6ik_15427.jpg", alt: "Готове до виїзду в Україну" },
  { url: "https://images.unsplash.com/photo-1668966643905-bf39ebd0577b?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", alt: "Німецький автобан" },
  { url: "https://images.unsplash.com/photo-1622103358651-97d6cb0df332?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", alt: "Доставка авто по Європі" },
  { url: "https://images.pexels.com/photos/19580036/pexels-photo-19580036.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=900", alt: "Заправка в Європі" },
];

export const TESTIMONIALS = [
  { name: "Олександр", city: "Київ", car: "BMW X5", text: "Шукав авто самостійно місяць — лише нерви. Тут отримав чесний звіт з відео, авто привезли без жодних сюрпризів. Номери українські вже на руках." },
  { name: "Ірина", city: "Львів", car: "VW Tiguan", text: "Найбільше цінувала, що спілкувалася з однією людиною від початку до кінця. Все пояснили, з розмитненням допомогли. Рекомендую." },
  { name: "Дмитро", city: "Одеса", car: "Audi A6", text: "Перше авто навіть не радив купувати — знайшов приховане фарбування товщиноміром. Підібрали інше, ідеальне. Це і є чесність." },
  { name: "Богдан", city: "Дніпро", car: "Skoda Octavia", text: "Бюджет був обмежений, але підібрали саме те, що треба. Доставка та реєстрація — все під ключ. Дякую за спокій." },
];

export const QUOTES = [
  "Моя робота — знайти автомобіль. Його робота — не зламатися дорогою додому.",
  "Купити автомобіль легко. Купити хороший автомобіль — це вже моя робота.",
  "Я шукаю не найдешевший автомобіль. Я шукаю автомобіль, який не стане найдорожчим після купівлі.",
  "Рекомендую лише ті автомобілі, які сам був би готовий купити для себе.",
];

export const FOOTER_SLOGAN = {
  line1: "Для вас на цьому реклама закінчується.",
  line2: "Для мене робота тільки починається.",
};
